'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCollapsible = require('react-collapsible');

var _reactCollapsible2 = _interopRequireDefault(_reactCollapsible);

var _container = require('@hixme-ui/container');

var _container2 = _interopRequireDefault(_container);

var _icon = require('@hixme-ui/icon');

var _icon2 = _interopRequireDefault(_icon);

var _ChevronRow = require('./ChevronRow');

var _ChevronRow2 = _interopRequireDefault(_ChevronRow);

var _Disabled = require('./Disabled');

var _Disabled2 = _interopRequireDefault(_Disabled);

var _InnerContent = require('./InnerContent');

var _InnerContent2 = _interopRequireDefault(_InnerContent);

var _StyledCard = require('./StyledCard');

var _StyledCard2 = _interopRequireDefault(_StyledCard);

var _StyledTrigger = require('./StyledTrigger');

var _StyledTrigger2 = _interopRequireDefault(_StyledTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Collapsible class names
var ContentInnerClassName = 'Collapsible__contentInner';

// Styled components


// hixme-ui

var TriggerClassName = 'Collapsible__trigger';

var CardDrawer = function (_Component) {
  (0, _inherits3.default)(CardDrawer, _Component);

  function CardDrawer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CardDrawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CardDrawer.__proto__ || (0, _getPrototypeOf2.default)(CardDrawer)).call.apply(_ref, [this].concat(args))), _this), _this.state = { stateOpen: _this.props.open }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CardDrawer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          cardContent = _props.cardContent,
          cardHeader = _props.cardHeader,
          collapsible = _props.collapsible,
          open = _props.open,
          children = _props.children,
          disabled = _props.disabled,
          hideArrow = _props.hideArrow;
      var stateOpen = this.state.stateOpen;


      var toggleDrawer = function toggleDrawer() {
        _this2.setState(function (prevState) {
          return {
            stateOpen: !prevState.stateOpen
          };
        });
      };

      return _react2.default.createElement(
        _Disabled2.default,
        { disabled: disabled },
        collapsible ? _react2.default.createElement(
          _reactCollapsible2.default,
          {
            easing: 'ease',
            open: stateOpen,
            handleTriggerClick: toggleDrawer,
            contentInnerClassName: ContentInnerClassName,
            triggerClassName: TriggerClassName,
            triggerOpenedClassName: TriggerClassName,
            trigger: _react2.default.createElement(
              _StyledTrigger2.default,
              { open: stateOpen, rounded: true, shadow: true, className: TriggerClassName },
              hideArrow ? _react2.default.createElement(
                _container2.default,
                { flex: true, noPadding: true, alignCenter: true },
                cardHeader
              ) : _react2.default.createElement(
                _container2.default,
                { flex: true, noPadding: true, justifySpaceBetween: true, alignCenter: true },
                _react2.default.createElement(
                  _container2.default,
                  { flex: true, noPadding: true, flexGrow: 1 },
                  cardHeader
                ),
                _react2.default.createElement(
                  _ChevronRow2.default,
                  { open: stateOpen, center: 'xs' },
                  _react2.default.createElement(_icon2.default, { arrowRight: true, size: 1.25 })
                )
              )
            ),
            transitionTime: 250
          },
          _react2.default.createElement(
            _InnerContent2.default,
            { className: ContentInnerClassName },
            cardContent || children
          )
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _StyledCard2.default,
            { round: true, shadow: true, open: open },
            cardHeader
          ),
          open && _react2.default.createElement(
            _InnerContent2.default,
            { className: ContentInnerClassName },
            cardContent || children
          )
        )
      );
    }
  }]);
  return CardDrawer;
}(_react.Component);

CardDrawer.propTypes = {
  cardContent: _propTypes2.default.node,
  cardHeader: _propTypes2.default.node,
  children: _propTypes2.default.node,
  hideArrow: _propTypes2.default.bool,
  collapsible: _propTypes2.default.bool,
  open: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};
CardDrawer.defaultProps = {
  cardContent: null,
  cardHeader: null,
  children: null,
  hideArrow: false,
  collapsible: false,
  open: true,
  disabled: false
};


CardDrawer.displayName = 'hui:CardDrawer';
CardDrawer.huiName = 'CardDrawer';

exports.default = CardDrawer;
//# sourceMappingURL=CardDrawer.js.map


//////////////////
// WEBPACK FOOTER
// ../card-drawer/lib/CardDrawer.js
// module id = 681
// module chunks = 0